import windowManipulationService from '@PROJECT_ROOT/assets/responsive-frontend/js/services/windowManipulationService';

/**
 * Return the id of the location targeted by the event
 * @param  {Event} event Occured event
 * @return {String}      Id of the location
 */
export function getLocationId(event) {
    return event.target.id;
}

/**
 * Return the name of the location targeted by the event
 * @param  {Event} event Occured event
 * @return {String}      Name of the location
 */
export function getLocationName(event) {
    return event.target.attributes.name.value;
}

/**
 * Indicate if the location targeted by the event is selected
 * @param  {Event} event Occured event
 * @return {Boolean}     Is the location selected
 */
export function getLocationSelected(event) {
    return event.target.attributes['aria-checked'].value === 'true';
}

/**
 * Update searchFrom fields based on array.
 * @param  {Array} selectedUnits Array "selectedUnits"
 * @return {Object}     Updated searchForm items
 */
// Zbog nove logike sa query parametrima iz rezultata pretrage, dodali smo jos jedan argument "customSearchFromQueryData"
// koji sadrži podatke o ukupnom broju gostiju iz search forme sa rezultata pretrage, argument je dodan zbog SSR-a, na CSR-u
// koristimo direktno izvlačenje iz "window.location.search".
export function updateSearchFormDataFromSelectedUnits(selectedUnits, customSearchFromQueryData) {
    let firstLevelQueryData = {};
    if (customSearchFromQueryData) {
        firstLevelQueryData = {
            searchFormAdultsCount: Number(customSearchFromQueryData.searchFormAdultsCount) || 0,
            searchFormChildren12to17Count: Number(customSearchFromQueryData.searchFormChildren12to17Count) || 0,
            searchFormChildren4to11Count: Number(customSearchFromQueryData.searchFormChildren4to11Count) || 0,
            searchFormChildren0to3Count: Number(customSearchFromQueryData.searchFormChildren0to3Count) || 0,
        };
    } else if (windowManipulationService.isBrowserEnvironment()) {
        const queryParams = new URLSearchParams(window.location.search);
        firstLevelQueryData = {
            searchFormAdultsCount: Number(queryParams.get('searchFormAdultsCount')) || 0,
            searchFormChildren12to17Count: Number(queryParams.get('searchFormChildren12to17Count')) || 0,
            searchFormChildren4to11Count: Number(queryParams.get('searchFormChildren4to11Count')) || 0,
            searchFormChildren0to3Count: Number(queryParams.get('searchFormChildren0to3Count')) || 0,
        };
    }
    if (!Array.isArray(selectedUnits) || selectedUnits.length === 0) {
        return {
            searchFormAdultsCount: 0,
            searchFormChildren0to3Count: 0,
            searchFormChildren4to11Count: 0,
            searchFormChildren12to17Count: 0,
        };
    }
    const searchFormAdultsCount = firstLevelQueryData?.searchFormAdultsCount || selectedUnits.reduce((total, unit) => total + Number(unit.adultsCount || 0), 0);
    const searchFormChildren0to3Count = firstLevelQueryData?.searchFormChildren0to3Count || selectedUnits.reduce((total, unit) => total + Number(unit.children0to3Count || 0), 0);
    const searchFormChildren4to11Count = firstLevelQueryData?.searchFormChildren4to11Count || selectedUnits.reduce((total, unit) => total + Number(unit.children4to11Count || 0), 0);
    const searchFormChildren12to17Count = firstLevelQueryData?.searchFormChildren12to17Count || selectedUnits.reduce((total, unit) => total + Number(unit.children12to17Count || 0), 0);
    // Ako budemo želili postavit uvijek bar jednu odraslu osobu.
    // const finalSearchFormAdultsCount = searchFormAdultsCount === 0 ? 1 : searchFormAdultsCount;
    const finalSearchFormAdultsCount = searchFormAdultsCount;

    return {
        searchFormAdultsCount: finalSearchFormAdultsCount,
        searchFormChildren0to3Count,
        searchFormChildren4to11Count,
        searchFormChildren12to17Count,
    };
}

/**
 * Sum all guests from one unit.
 * @param  {Object}
 * @return {Number}
 */
export function sumAllUnitGuests(unitData) {
    const adultsCount = Number(unitData.adultsCount) || 0;
    const children0to3Count = Number(unitData.children0to3Count) || 0;
    const children4to11Count = Number(unitData.children4to11Count) || 0;
    const children12to17Count = Number(unitData.children12to17Count) || 0;
    return adultsCount + children0to3Count + children4to11Count + children12to17Count;
}

/**
 * Sum all children from one unit.
 * @param  {Object}
 * @return {Number}
 */
export function sumAllUnitChildren(unitData) {
    const children0to3Count = Number(unitData.children0to3Count) || 0;
    const children4to11Count = Number(unitData.children4to11Count) || 0;
    const children12to17Count = Number(unitData.children12to17Count) || 0;
    return children0to3Count + children4to11Count + children12to17Count;
}

export function formatGuestsDisplayText(args) {
    const {
        numberOfPersons,
        numberOfAdults,
        numberOfChildren,
        withChildrenTemplate,
        adultsOnlyTemplate,
        splitText,
        forceChildrenTemplate,
    } = args;

    if (numberOfChildren > 0 || forceChildrenTemplate) {
        const fullText = withChildrenTemplate
            .replace('{{TOTAL_PERSONS_COUNT}}', numberOfPersons)
            .replace('{{ADULTS_COUNT}}', numberOfAdults)
            .replace('{{KIDS_COUNT}}', numberOfChildren);
        if (splitText) {
            const totalnumberOfPersonsStr = String(numberOfPersons);
            const splitIndex = fullText.indexOf(totalnumberOfPersonsStr) + totalnumberOfPersonsStr.length;
            return [
                fullText.slice(0, splitIndex),
                fullText.slice(splitIndex).trim(),
            ];
        }
        return fullText;
    }
    return adultsOnlyTemplate
        .replace('{{TOTAL_PERSONS_COUNT}}', numberOfPersons)
        .replace('{{ADULTS_COUNT}}', numberOfAdults);
}

/**
 * Return appVersion.
 */
export function getBuildVersion() {
    return window.AppConfig.appVersion || 'Nepoznata verzija iz getBuildReleaseName';
}
